module.exports = __webpack_public_path__ + "static/media/mastercard.4557829e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastercard.svg
// module id = 1152
// module chunks = 2